// ══════════════════════════════════════════════════════════════
// COMPASS – Correlation ID Interceptor
// ══════════════════════════════════════════════════════════════
import { HttpInterceptorFn } from '@angular/common/http';
import { generateUUID } from '../utils/uuid';

/**
 * Functional HTTP interceptor that attaches a unique
 * `X-Correlation-Id` header to every outgoing request
 * for distributed tracing with backend services.
 */
export const correlationIdInterceptor: HttpInterceptorFn = (req, next) => {
  const correlationId = generateUUID();

  const clonedReq = req.clone({
    setHeaders: { 'X-Correlation-Id': correlationId },
  });

  return next(clonedReq);
};
